// extracted by mini-css-extract-plugin
export default {"productCarousel":"g1-z"};